import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from '../../stores/auth';

export function Welcome() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  useEffect(() => {
    if (user) navigate('/onboarding/circle', { replace: true });
  }, [user, navigate]);

  return (
    <div className="mx-auto flex min-h-screen max-w-screen-sm flex-col items-center justify-center bg-base px-6 text-text-primary">
      <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-2xl bg-sage text-2xl font-bold text-white">N</div>
      <h1 className="text-center text-2xl font-medium">Welcome to Nudge</h1>
      <p className="mt-3 max-w-sm text-center text-sm text-text-muted">
        Send a card. Skip the words. Built for couples and small circles who feel things deeply and don't always have language ready.
      </p>
      <button
        onClick={() => navigate('/onboarding/name')}
        className="mt-10 w-full max-w-xs rounded-xl bg-sage py-3 text-base font-medium text-white"
      >
        Get started
      </button>
      <Link to="/" className="mt-4 text-xs text-text-muted underline">Back to website</Link>
    </div>
  );
}
